import { useState, useRef } from 'react';
import _ from 'underscore';

/**
 * Stores table row object and offers methods to sort it based on a column.
 * This hook should be used to sort semantic ui tables.
 * @param {object} rows
 * @return {object} a table sorter object with the current ordered rows, the onUpdate method (to update rows),
 * the sorting method and getSorted that returns the value for the sorted prop (part of the semantic ui table)
 */
export default function useTableSorter(rows) {
  const [sortedRows, sortRows] = useState(rows);
  const [direction, setDirection] = useState(null);
  const column = useRef(null);

  const onUpdate = (data) => {
    if (column) {
      data = _.sortBy(data, [column]);
    }
    sortRows(data);
  };

  const onSort = (newSelectedColumn) => {
    if (column.current !== newSelectedColumn) {
      _sortByNewColumn(newSelectedColumn);
      return;
    }
    setDirection(direction === 'ascending' ? 'descending' : 'ascending');
    sortRows(sortedRows.reverse());
  };

  const _sortByNewColumn = (newColumn) => {
    column.current = newColumn;
    setDirection('ascending');
    sortRows(_.sortBy(sortedRows, [newColumn]));
  };

  return {
    sortedRows,
    onUpdate: (newRows) => onUpdate(newRows),
    onSort: (newSelectedColumn) => onSort(newSelectedColumn),
    getSorted: (target) => (column.current === target ? direction : null),
  };
}
